import {createContext, useContext, useState} from "react";
import {useTable} from "hooks/useTable";
import PortfolioApi from "api/portfolio.api";
import {
    servicePortfolioDestroy,
    servicePortfolioOrder,
    servicePortfolioSave,
    servicePortfolioUpdateAction
} from "services/portfolio.service";

const PortfolioContext = createContext();

export const PortfolioProvider = ({children}) => {

    const translateKey = 'crm.Portfolio';
    const permission = 'portfolio';
    const [tableRow, setTableRow] = useState({});
    const [filter, setFilter] = useState({});
    const [modal, setModal] = useState({
        form: false
    });

    const {dataSource, setDataSource, loading: tableLoading, fetchDataSource, handleQuery, query} = useTable(PortfolioApi.getIndex);

    const handleFilter = (newFilter) => {
        setFilter(f => ({
            ...f,
            ...newFilter
        }))
    }

    const handleModal = (name, action, data = {}) => {
        setModal(m => ({
            ...m,
            [name]: action
        }))
        setTableRow(data);
    }

    const handleAction = async (id, action = 'is_active') => {
        const res = await servicePortfolioUpdateAction(id, action);
        if (res) await fetchDataSource();
    }

    const handleDelete = async (id) => {
        const res = await servicePortfolioDestroy(id);
        if (res) await fetchDataSource();
    }

    const handleSave = async (form) => {
        const res = await servicePortfolioSave(form)
        if (res) {
            await fetchDataSource();
            return true;
        }
        return false;
    }

    const handleOrderChange = async (value, id) => {
        const index = dataSource.data.findIndex(i => i.id === id);
        dataSource.data[index].order = value;
        setDataSource(d => ({
            ...d,
            data: [...dataSource.data]
        }));
    }

    const handleOrderSave = async (value, id) => {
        if (value && id) {
            const res = await servicePortfolioOrder(id, {order: value});
            if (res) {
                await fetchDataSource()
            }
        }
    }

    const values = {
        translateKey,
        modal,
        permission,
        filter,
        tableRow,
        dataSource,
        query,
        tableLoading,
        fetchDataSource,
        handleQuery,
        handleModal,
        handleFilter,
        handleAction,
        handleDelete,
        handleSave,
        handleOrderChange,
        handleOrderSave
    };

    return <PortfolioContext.Provider value={values}>
        {children}
    </PortfolioContext.Provider>
}

export const usePortfolioContext = () => useContext(PortfolioContext);
